import { useEffect } from "react";
import { applySeo } from "../lib/seo";

const Seo = (props) => {
  useEffect(() => {
    applySeo(props);
  }, [props]);

  return null;
};

export default Seo;
